import { Injectable } from '@angular/core';
import { AudienceFilter, AudiencePreview } from '../../domain/models/audience-filter.model';
import { Campaign, CampaignCtaAction, CampaignStatus } from '../../domain/models/campaign.model';
import { CampaignInput } from '../../domain/models/campaign-input.model';
import { CampaignKpi } from '../../domain/models/campaign-kpi.model';
import { CampaignRecipient } from '../../domain/models/campaign-recipient.model';
import { EmailPreviewRequest } from '../../domain/models/email-preview-request.model';
import {
  AudienceFilterRequestDto, AudiencePreviewDto, CampaignDto, CampaignKpiDto, CampaignRecipientDto,
  CreateCampaignRequestDto, EmailPreviewRequestDto,
} from '../dtos/campaign.dto';

@Injectable()
export class CampaignMapper {
  public toCampaign(dto: CampaignDto): Campaign {
    return {
      id: dto.Id,
      organizationId: dto.OrganizationId,
      name: dto.Name,
      channel: dto.Channel,
      status: dto.Status as CampaignStatus,
      audienceMinDaysSinceVisit: dto.AudienceMinDaysSinceVisit,
      audienceHasPendingInvoice: dto.AudienceHasPendingInvoice,
      audienceTag: dto.AudienceTag,
      subject: dto.Title,
      bodyText: dto.Body,
      ctaAction: dto.PushAction as CampaignCtaAction,
      ctaCustomUrl: dto.PushUrl,
      scheduledAtUtc: dto.ScheduledAtUtc,
      sentAtUtc: dto.SentAtUtc,
      recipientCount: dto.RecipientCount,
      excludedNoEmailCount: dto.ExcludedNoEmailCount,
      excludedUnlinkedCount: dto.ExcludedUnlinkedCount,
      excludedConsentCount: dto.ExcludedConsentCount,
      excludedNoDeviceCount: dto.ExcludedNoDeviceCount,
      deliveredCount: dto.DeliveredCount,
      failedCount: dto.FailedCount,
      openCount: dto.OpenCount,
      clickCount: dto.ClickCount,
      createdAtUtc: dto.CreatedAtUtc,
      updatedAtUtc: dto.UpdatedAtUtc,
    };
  }

  public toKpi(dto: CampaignKpiDto): CampaignKpi {
    return {
      totalCampaigns: dto.TotalCampaigns,
      draftCampaigns: dto.DraftCampaigns,
      scheduledCampaigns: dto.ScheduledCampaigns,
      sendingCampaigns: dto.SendingCampaigns,
      sentCampaigns: dto.SentCampaigns,
      pausedCampaigns: dto.PausedCampaigns,
      failedCampaigns: dto.FailedCampaigns,
      totalRecipients: dto.TotalRecipients,
      totalDelivered: dto.TotalDelivered,
      totalFailed: dto.TotalFailed,
    };
  }

  public toRecipient(dto: CampaignRecipientDto): CampaignRecipient {
    return {
      id: dto.Id,
      clientExternalId: dto.ClientExternalId,
      clientEmail: dto.ClientEmail,
      clientName: dto.ClientName,
      appClientId: dto.AppClientId,
      exclusionReason: dto.ExclusionReason,
      status: dto.Status,
      sentAtUtc: dto.SentAtUtc,
      readAtUtc: dto.ReadAtUtc,
      actionClickedAtUtc: dto.ActionClickedAtUtc,
      errorMessage: dto.ErrorMessage,
      createdAtUtc: dto.CreatedAtUtc,
    };
  }

  public toAudiencePreview(dto: AudiencePreviewDto): AudiencePreview {
    return {
      matchingBeforeExclusion: dto.MatchingBeforeExclusion,
      excludedUnlinked: dto.ExcludedUnlinked,
      excludedConsent: dto.ExcludedConsent,
      excludedNoDevice: dto.ExcludedNoDevice,
      totalRecipients: dto.TotalRecipients,
    };
  }

  public toCreateRequest(input: CampaignInput): CreateCampaignRequestDto {
    return {
      Name: input.name,
      Channel: input.channel,
      AudienceMinDaysSinceVisit: input.audienceMinDaysSinceVisit,
      AudienceHasPendingInvoice: input.audienceHasPendingInvoice,
      AudienceTag: input.audienceTag,
      Title: input.subject,
      Body: input.bodyText,
      PushAction: input.ctaAction,
      PushUrl: input.ctaCustomUrl,
    };
  }

  public toAudienceFilterRequest(filter: AudienceFilter): AudienceFilterRequestDto {
    return {
      MinDaysSinceVisit: filter.minDaysSinceVisit,
      HasPendingInvoice: filter.hasPendingInvoice,
      Tag: filter.tag,
    };
  }

  public toEmailPreviewRequest(request: EmailPreviewRequest): EmailPreviewRequestDto {
    return {
      Title: request.subject,
      Body: request.bodyText,
      PushAction: request.ctaAction,
      PushUrl: request.ctaCustomUrl,
    };
  }
}
